import { render, staticRenderFns } from "./tab-menu.vue?vue&type=template&id=6ee45016"
import script from "./tab-menu.vue?vue&type=script&lang=js"
export * from "./tab-menu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports